import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getAgentReportingStats = createAsyncThunk("AgentsReportingList/getAgentReportingStats", async (data, thunkAPI) => {
  try {
    const resp = await axios.get(
      `${process.env.REACT_APP_BASE_URL}api/recruitment/report/agent-activity?startDate=${data.fromDate}&endDate=${data.lastDate}&userId=${data.userId || ""}&granularity=${
        data?.granularity || ""
      }`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return resp.data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
